import PropTypes from 'prop-types';
import React from 'react';

import t from '../../lib/I18n';
import config from '../../config';

import BaseModal from '../general/BaseModal';
import BAlert, { bAlertType } from '../general/BAlert';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';

const InAppVersionEndingModal = ({ show }) => {
    const appStoreUrl = config.get('inAppVersionEndingAppStoreUrl') || config.get('appStoreAppUrl');
    const googlePlayUrl = config.get('inAppVersionEndingGooglePlayUrl') || config.get('googlePlayAppUrl');

    return (
        <BaseModal
            show={ show }
            disableBlur
            disableEscape
            hideClose
            hideContinue
            footer={ false }
            className="modal--sm"
            titleText="inApp.versionEnding.header"
        >
            <div className="vertical-align-parent full-height">
                <BAlert type={ bAlertType.DANGER } className="padding-top">
                    <p className='text-weight--bold'><FormattedHTMLMessage message="inApp.versionEnding.body" /></p>
                    <p className="margin-top--sm text-weight--bold">{ t('inApp.versionEnding.cta') }</p>
                    <div className="margin-top--sm">
                        <a href={ appStoreUrl } target="_blank" rel="noopener noreferrer">
                            <img
                                src="/images/mobile-apps/app-store.png"
                                alt={ t('ontrackapp.widget.appstoreButtonAltText') }
                            />
                        </a>
                        <a href={ googlePlayUrl } target="_blank" rel="noopener noreferrer">
                            <img
                                src="/images/mobile-apps/google-play.png"
                                alt={ t('ontrackapp.widget.googlePlayButtonAltText') }
                            />
                        </a>
                    </div>
                </BAlert>
            </div>
        </BaseModal>
    );
};

InAppVersionEndingModal.propTypes = {
    show: PropTypes.bool
};

InAppVersionEndingModal.defaultProps = {
    show: true
};

export default InAppVersionEndingModal;
